import React from 'react';
import NotificationTable from '../notification-table';
import {history} from '../../../../store';

const actions = [
  {
    label: 'View',
    callback: (row) => {
      history.push(`/admin/sms-logs/${row.id}`);
    },
  },
];

const SmsNotificationTable = ({ notifications, ...rest}) => (
  <NotificationTable
    title="Sms"
    actions={actions}
    notifications={notifications}
    {...rest}
  />
);

export default SmsNotificationTable;



// WEBPACK FOOTER //
// ./src/components/admin/notifications/sms/sms-notification-table.jsx